import { render, staticRenderFns } from "./ChapterCategoriesFilters.vue?vue&type=template&id=a4fbfdaa&scoped=true&lang=pug"
import script from "./ChapterCategoriesFilters.vue?vue&type=script&lang=js"
export * from "./ChapterCategoriesFilters.vue?vue&type=script&lang=js"
import style0 from "./ChapterCategoriesFilters.vue?vue&type=style&index=0&id=a4fbfdaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fbfdaa",
  null
  
)

export default component.exports